import RequestAbstract from "./RequestAbstract";

/**
 * Created by viclight on 04.03.2024.
 */
export default class EmployeesDetails extends RequestAbstract {

    get link() {
        return this.links.doctors;
    }

}
